<div class="center" *ngIf="loading" style="margin-top: 40px;">
  <mat-spinner [diameter]="25"></mat-spinner>
  <p style="margin-right: 16px;">در حال بارگذاری...</p>
</div>

<ng-container *ngIf="!loading">
  <div class="container1000">
    <div class="row-center flex">
      <h3 class="page-head flex">تراکنش مالی</h3>
      <div class="flex"></div>

    </div>
    <p style="margin-bottom: 16px;">این لیست، تراکنش های مالی شما را با مشخصات مربوطه نمایش می‌دهد.</p>
    <form [formGroup]="form" class="row row-responsive" style="margin: 8px 0;">
      <div class="flex"></div>
      <mat-card style="margin-bottom: 16px;" class="column">
        <button style="margin-bottom: 10px;" mat-button>
          <mat-icon>monetization_on</mat-icon>
          کیف پول
        </button>
        <div class="row">
          <div class="flex"></div>
          <div class="amount flex">
            {{walletAmount|number}}
          </div>
        </div>
      </mat-card>
      <mat-card style="margin-bottom: 16px;" class="row-center">
        <div class="row-center">
          <button style="margin-bottom: 10px;" (click)="showFilter = !showFilter" mat-button>
            <mat-icon>filter_list</mat-icon>
            فیلتر
          </button>
        </div>
        <ng-container *ngIf="showFilter">
          <mat-form-field class="flex">
            <mat-label>تاریخ شروع</mat-label>
            <input matInput formControlName="startDate" [max]="nowDate" [matDatepicker]="picker1">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error>تاریخ معتبر نیست</mat-error>
          </mat-form-field>
          <mat-form-field class="flex">
            <mat-label>تاریخ پایان</mat-label>
            <input matInput formControlName="endDate" [max]="nowDate" [min]="form.value.startDate"
              [matDatepicker]="picker">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error>تاریخ معتبر نیست</mat-error>
          </mat-form-field>
          <button [disabled]="form.invalid" color="accent" (click)="search()" mat-raised-button>
            <mat-icon>search</mat-icon>
            جستجو
          </button>
        </ng-container>
      </mat-card>
      <!-- <div class="flex"></div> -->

      <div class="flex"></div>
    </form>
    <bt-table [configsTable]="configTable" (pageSelected)="pageSelected($event)" [data]="data"
      [pageNumber]="pageNumber"></bt-table>
  </div>
</ng-container>
